import { withRouter } from "react-router-dom";
import { useSelector ,useDispatch} from "react-redux";
import { useHistory } from "react-router";
import { useState } from "react";
import { addToCart } from "../redux/cartSlice";
import ProductDetail from "./ProductDetails";
import _ from "lodash";
import { toast } from "react-toastify";
import { MotionImage, ScroolMotionDiv } from "../components/motion/AllMotions";
import { useEffect } from "react";
import { scaleImage } from "../provider/functions";
export default withRouter(ProductPage);
function ProductPage(props) {
  const { id,table,server } = props.match.params;
  const product = useSelector((state) =>
    state.products.data.find((v) => v.id == id)
  );
  const isWebStore = table=="webstore" ||table=="online";
  const serverReducer = useSelector((state) => state.server.data);
  const languageReducer = useSelector((state) => state.language);
  const language = languageReducer.data;
  const selected = languageReducer.selected
  const dispatch = useDispatch();
  const {currency,qrSiparis,textColor,buttonColor,bgcolor1} = useSelector((state) =>state.server.data);
  const [qt, setqt] = useState(1)
  const [showModal, setshowModal] = useState(false)
  const { title, price, options, image, quantity,category,stok,stokluSatis } = product;
  const [note, setnote] = useState("");
  const [optionsData, setoptionsData] = useState([...options]);
  const optionsPrice = optionsData.reduce((a,b)=>a.concat(b.data),[]).filter(v=>v.checked).map(v=>parseFloat( v.price)).reduce((a,b)=>a+b,0)
  const productPrice =parseFloat((parseFloat(price)+parseFloat(optionsPrice))*qt).toFixed(2)
  function checkBox(i, ii) {
    let myoptions = JSON.parse(JSON.stringify([...optionsData].filter(v=>!v.hideQr)));
    const ayar = myoptions[i].multiple;
    const max = myoptions[i].max || ((ayar == "multiple" || ayar=="yes" || ayar==true)?99:1);
    myoptions[i].data[ii].checked = !myoptions[i].data[ii].checked;
    //const min = myoptions[i].min || 0;
    const howManyChecked = [...myoptions[i].data].filter(v=>v.checked).length;
    if(max==1){
      myoptions[i].data = myoptions[i].data.map((v,i2)=>({...v,checked:i2!=ii?false:!!v.checked}))
      setoptionsData(myoptions);
    }
    if(howManyChecked>max){
      toast.clearWaitingQueue();
      return toast.error(language.add_to_cart_order_options_max_limit,{
        toastId: String(i)+String(ii),
        duration:2000,
        position: 'bottom-center',
      })
    }    
    setoptionsData(myoptions);
  }

  function addCart() {
    const findNotPicked = [...optionsData].filter(v=>!v.hideQr).find(value=>{
      const checked = value.data.filter(v=>v.checked).length
      if(value.min>checked) return true;
      if(value.max<checked) return true;
      return false;
    })
    if(findNotPicked){
      const checked = findNotPicked.data.filter(v=>v.checked).length
      if(findNotPicked.min>checked) toast.error(language.add_to_cart_order_options_required)
      if(findNotPicked.max<checked) toast.error(language.add_to_cart_order_options_max_limit)
      return ;
    }
    dispatch(
      addToCart({product,quantity:qt,options:optionsData,note})
    );
    toast.success(((product.languages && product.languages[selected]) ?  product.languages[selected].title : (product.qrTitle || product.title)) + " "+language.sepete_ekle_success, {
      position: "top-right",
      autoClose: 2500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
   
    props.history.replace((server?"/"+server:"")+"/"+table+"/categories/")
    // history.replace((match.params.server?"/"+match.params.server:"")+"/"+match.params.table+"/categories/",{id:category})
  }
  function plusOne(){
    const arttir = parseInt(qt) + 1;
    if(stokluSatis && arttir>stok){
      setqt(stok);
      return false;
    }
    setqt(arttir);
  }
  useEffect(()=>{
    window.scrollTo(0,0)
  },[])
  return (
    <div>
  <div className="rp-app rp-details ">
    <div className="container-fluid ">
      <div className="rp-page-head rp-detail-head">
        <a onClick={()=>
          showModal ? setshowModal(false) : props.history.replace((server?"/"+server:"")+"/"+table+"/categories/",{productId:id})
        } className="back" style={{position:'fixed'}}><i className="fa fa-arrow-left" /></a>
        <a  className="heart active"><i className="fa fa-heart" /></a>
      </div>
      <div className="rp-detail-img" style={{position:'relative'}}>
      {product.image &&<div className="owl-carousel owl-theme" id="detail-images">
          <div className="item">
            <img src={scaleImage(product.image,800)} />
          </div>
        </div>}
     {(qrSiparis || isWebStore) && (
        <div style={{
          position:'absolute',
          bottom:16,
          left:'50%',
          transform:'translateX(-50%)',
          zIndex:10,
          display:'flex',
          alignItems:'center',
          gap:0,
          background:'rgba(15,15,15,0.72)',
          backdropFilter:'blur(14px)',
          WebkitBackdropFilter:'blur(14px)',
          borderRadius:999,
          border:'1.5px solid rgba(255,255,255,0.13)',
          boxShadow:'0 8px 32px rgba(0,0,0,0.38)',
          padding:'4px 4px',
          height:44,
        }}>
          <button
            type="button"
            onClick={()=>qt>1 ? setqt(parseInt(qt)-1):null}
            style={{
              width:36,height:36,borderRadius:'50%',border:'none',
              background: qt>1 ? 'rgba(255,255,255,0.12)' : 'rgba(255,255,255,0.04)',
              color: qt>1 ? '#fff' : 'rgba(255,255,255,0.3)',
              fontSize:20,fontWeight:300,lineHeight:1,cursor: qt>1 ? 'pointer':'default',
              display:'flex',alignItems:'center',justifyContent:'center',
              transition:'background 0.15s, color 0.15s',outline:'none',padding:0,flexShrink:0,
            }}>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M2 7h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
          <input
            type="number"
            min={1}
            name="quantity"
            value={qt+""}
            onChange={(e)=>setqt(e.target.value)}
            style={{
              width:36,textAlign:'center',background:'transparent',border:'none',
              color:'#fff',fontSize:15,fontWeight:700,fontFamily:'inherit',
              outline:'none',MozAppearance:'textfield',
              WebkitAppearance:'none',padding:0,lineHeight:1,
            }}
          />
          <button
            type="button"
            onClick={()=>plusOne()}
            style={{
              width:36,height:36,borderRadius:'50%',border:'none',
              background: bgcolor1 || '#000',
              color:'#fff',
              fontSize:20,fontWeight:300,lineHeight:1,cursor:'pointer',
              display:'flex',alignItems:'center',justifyContent:'center',
              boxShadow:`0 2px 10px ${bgcolor1 || '#000'}60`,
              transition:'background 0.15s, box-shadow 0.15s',outline:'none',padding:0,flexShrink:0,
            }}>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M7 2v10M2 7h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>
      )}
      </div>
      {/* <div className="rp-detail-mini">
        <div className="row">
          <div className="col"><span className="stars"><i className="fa fa-star" /> 5.0</span></div>
          <div className="col"><span className="min"><i className="fa fa-tachometer-alt" /> Hızlı Servis</span></div>
          <div className="col"><span className="shipping"><i className="fa fa-dollar-sign" /> Önerilenler</span></div>
        </div>
      </div> */}
      <ScroolMotionDiv className="rp-detail-info bg-light card" style={{paddingRight:10,paddingLeft:10,borderRadius:10}} initial={{ opacity: 0,x:-50 }}
   whileInView={{ opacity: 1,x:0 }}>
        <h2 className="name" style={{fontWeight:'bold',color:"black",marginTop:30}}>{(product.languages && product.languages[selected]) ?  product.languages[selected].title : (product.qrTitle || product.title)}</h2>
        <p className="text" style={{color:"black"}}> {(product.languages && product.languages[selected]) ?  product.languages[selected].description : (product.qrDesc || " ")}</p>
      {optionsData.filter(v=>!v.hideQr).map((option,key)=>{
        const ayar = option.multiple;
        const max = option.max || ((ayar=="multiple"||ayar=="yes"||ayar==true)?99:1);
        const isRadio = max === 1;
        const checkedCount = option.data.filter(v=>v.checked).length;
        const isRequired = option.min > 0;
        return (
        <div key={key} style={{marginBottom:24}}>
          {/* --- Group Header --- */}
          <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:12}}>
            <div style={{display:'flex',alignItems:'center',gap:8}}>
              <span style={{
                fontWeight:700,
                fontSize:15,
                color:'#111',
                letterSpacing:'-0.3px'
              }}>{option.title}</span>
              {isRequired && <span style={{
                fontSize:10,
                fontWeight:700,
                letterSpacing:'0.5px',
                textTransform:'uppercase',
                backgroundColor:'#111',
                color:'#fff',
                borderRadius:6,
                padding:'2px 7px',
              }}>{language.zorunlu_alan || "Zorunlu"}</span>}
            </div>
            <span style={{
              fontSize:11,
              fontWeight:600,
              color: checkedCount>0 ? (bgcolor1 || '#000') : '#999',
              backgroundColor: checkedCount>0 ? `${bgcolor1 || '#000'}1a`:'rgba(0,0,0,0.05)',
              borderRadius:20,
              padding:'3px 10px',
              transition:'all 0.2s',
            }}>
              {isRadio ? (checkedCount>0?language.secildi || 'Seçildi':language.sec || 'Seç') : `${checkedCount}/${option.max||'∞'}`}
            </span>
          </div>

          {/* --- Divider --- */}
          <div style={{height:1,background:'linear-gradient(90deg,#111 0%,rgba(0,0,0,0.06) 100%)',marginBottom:12,borderRadius:2}}/>

          {/* --- Option Chips --- */}
          <div style={{display:'flex',flexWrap:'wrap',gap:10}}>
            {option.data.map((op,keyy)=>(
              <button
                key={keyy}
                type="button"
                onClick={()=>checkBox(key,keyy)}
                style={{
                  display:'flex',
                  alignItems:'center',
                  gap:8,
                  padding:'10px 14px',
                  borderRadius:14,
                  border: op.checked ? '2px solid #111' : '2px solid #bbb',
                  background: op.checked
                    ? 'linear-gradient(135deg,#1a1a1a 0%,#333 100%)'
                    : '#f5f5f5',
                  color: op.checked ? '#fff' : '#222',
                  cursor:'pointer',
                  fontFamily:'inherit',
                  fontSize:13,
                  fontWeight: op.checked ? 700 : 600,
                  boxShadow: op.checked
                    ? '0 4px 16px rgba(0,0,0,0.22)'
                    : '0 2px 8px rgba(0,0,0,0.10)',
                  transform: op.checked ? 'none' : 'none',
                  outline:'none',
                  position:'relative',
                  transition:'border 0.15s, background 0.15s, box-shadow 0.15s, color 0.15s',
                  minWidth: 0,
                }}
              >
                {/* Custom checkmark indicator */}
                <span style={{
                  width:18,
                  height:18,
                  borderRadius: isRadio ? '50%' : 5,
                  border: op.checked ? `2px solid ${bgcolor1 || '#000'}` : '2px solid #aaa',
                  background: op.checked ? (bgcolor1 || '#000') : 'rgba(0,0,0,0.05)',
                  display:'flex',
                  alignItems:'center',
                  justifyContent:'center',
                  flexShrink:0,
                  transition:'all 0.15s',
                }}>
                  {op.checked ? (
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                      <path d={isRadio ? "M5 2.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5z" : "M1.5 5l2.5 2.5 4.5-5"} stroke="#1a1a1a" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill={isRadio?"#1a1a1a":"none"}/>
                    </svg>
                  ) : (
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                      <path d="M5 2v6M2 5h6" stroke="#888" strokeWidth="1.8" strokeLinecap="round"/>
                    </svg>
                  )}
                </span>

                <span style={{flex:1,textAlign:'left',lineHeight:1.3}}>
                  {_.capitalize(String(op.title))}
                </span>

                {/* Price badge */}
                <span style={{
                  fontSize:11,
                  fontWeight:700,
                  color: op.checked ? (bgcolor1 || '#000') : '#888',
                  background: op.checked ? `${bgcolor1 || '#000'}26` : 'rgba(0,0,0,0.05)',
                  borderRadius:8,
                  padding:'2px 7px',
                  whiteSpace:'nowrap',
                  transition:'all 0.15s',
                }}>
                  +{op.price} {currency}
                </span>
              </button>
            ))}
          </div>
        </div>
        )}
      )}
        {(qrSiparis || isWebStore) &&  <>
          <div style={{display:'flex',alignItems:'center',gap:8,marginTop:24,marginBottom:10}}>
            <span style={{fontWeight:700,fontSize:15,color:'#111',letterSpacing:'-0.3px'}}>{language.siparis_notu}</span>
            <span style={{fontSize:10,fontWeight:600,letterSpacing:'0.5px',textTransform:'uppercase',color:'#999',backgroundColor:'rgba(0,0,0,0.05)',borderRadius:6,padding:'2px 7px'}}>{language.istege_bagli || "İstege Bağlı"}</span>
          </div>
          <div style={{height:1,background:'linear-gradient(90deg,rgba(0,0,0,0.15) 0%,rgba(0,0,0,0.04) 100%)',marginBottom:10,borderRadius:2}}/>
          <textarea
            rows={2}
            className="form-control"
            value={note}
            onChange={(val)=>setnote(val.target.value)}
            style={{
              borderRadius:14,
              border:'2px solid #e8e8e8',
              fontSize:13,
              padding:'10px 14px',
              resize:'none',
              fontFamily:'inherit',
              color:'#111',
              outline:'none',
              boxShadow:'0 1px 4px rgba(0,0,0,0.06)',
            }}
          />
        </>}
        <div style={{height:35}}/>
      </ScroolMotionDiv>
      
      {/* <div className="rp-detail-brand flex-between">
        <div className="left flex-start">
          <div className="icon"><img src="assets/img/burger.png" alt="Brand" /></div>
          <div className="content">
            <span className="name">Kawsar Food</span>
            <span className="desc">1.6 Km from you</span>
          </div>
        </div>
        <div className="right">
          <div className="stars">
            <i className="fa fa-star" />
            <i className="fa fa-star" />
            <i className="fa fa-star" />
            <i className="fa fa-star" />
            <i className="fa fa-star gray" />
          </div>
        </div>
      </div> */}
      {(qrSiparis || isWebStore) && (
        <div style={{
          position:'fixed',
          bottom:0,left:0,right:0,
          zIndex:999,
          padding:'12px 16px 24px',
          background:'rgba(255,255,255,0.92)',
          backdropFilter:'blur(24px)',
          WebkitBackdropFilter:'blur(24px)',
          borderRadius:'24px 24px 0 0',
          boxShadow:'0 -8px 40px rgba(0,0,0,0.10)',
        }}>
          <button
            type="button"
            onClick={addCart}
            style={{
              width:'100%',
              height:56,
              borderRadius:16,
              border:'none',
              background:  '#e74c3c',
              fontFamily:'inherit',
              cursor:'pointer',
              display:'flex',
              alignItems:'center',
              justifyContent:'space-between',
              padding:'0 8px 0 16px',
              boxShadow:`0 6px 28px ${'#e74c3c'}60`,
              outline:'none',
              transition:'opacity 0.15s, box-shadow 0.15s',
              gap:8,
            }}>
            {/* Left: icon + label */}
            <div style={{display:'flex',alignItems:'center',gap:8,flexShrink:0}}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <line x1="3" y1="6" x2="21" y2="6" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
                <path d="M16 10a4 4 0 01-8 0" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span style={{fontSize:15,fontWeight:800,letterSpacing:'-0.3px',color:'#fff',whiteSpace:'nowrap'}}>
                {language.sepete_ekle}
              </span>
            </div>
            {/* Right: price pill */}
            <span style={{
              background:'rgba(255,255,255,0.2)',color:'#fff',
              borderRadius:10,padding:'7px 14px',
              fontSize:11,fontWeight:800,letterSpacing:'-0.2px',
              whiteSpace:'nowrap',lineHeight:1,flexShrink:0,
            }}>{productPrice} {currency}</span>
          </button>
        </div>
      )}
    </div>
  </div>
  <div style={{height:100}}/>

</div>

  )
  
}
